var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.54518 1.54531C0.666504 2.42399 0.666504 3.8382 0.666504 6.66662V21.3333C0.666504 24.1617 0.666504 25.5759 1.54518 26.4546C2.42386 27.3333 3.83808 27.3333 6.6665 27.3333H21.3332C24.1616 27.3333 25.5758 27.3333 26.4545 26.4546C27.3332 25.5759 27.3332 24.1617 27.3332 21.3333V6.66663C27.3332 3.8382 27.3332 2.42399 26.4545 1.54531C25.5758 0.666626 24.1616 0.666626 21.3332 0.666626H6.6665C3.83808 0.666626 2.42386 0.666626 1.54518 1.54531ZM21.4986 10.5547C21.8049 10.0951 21.6807 9.47426 21.2212 9.16791C20.7617 8.86156 20.1408 8.98573 19.8345 9.44526L15.457 16.0115L14.3316 13.7607C13.6448 12.3871 11.7304 12.268 10.8786 13.5457L6.50112 20.1119C6.19477 20.5715 6.31895 21.1923 6.77847 21.4987C7.238 21.805 7.85887 21.6809 8.16522 21.2213L12.5427 14.6551L13.6681 16.9059C14.3549 18.2794 16.2692 18.3986 17.1211 17.1209L21.4986 10.5547Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStat);
export default __webpack_public_path__ + "static/media/stat.aeaa4febbf3a5e050117fc994648e503.svg";
export { ForwardRef as ReactComponent };